export const IPSNonEAMTemplateHeaders = [
    { label: "S.No.", key: "sNo" },
    { label: "Region*", key: "region" },
    { label: "Cluster Center*", key: "clusterCenter" },
    { label: "Site", key: "site" },
    { label: "L1 Category", key: "l1Category" },
    { label: "L2 Category", key: "l2Category" },
    { label: "Service Description*", key: "serviceDescription" },
    { label: "Frequency", key: "frequency" },
    { label: "Unit Of Measure", key: "unitOfMeasure" },
    { label: "Qty", key: "qty" },
    { label: "Additional Comments", key: "additionalComments" },
    { label: "Unit Cost", key: "unitCost" },
    { label: "Total", key: "total" },
    { label: "Currency", key: "currency" },
    { label: "Supplier OFA ID", key: "supplierOfaId" }
];

export const IPSNonEAMHeaderListForProcessing = IPSNonEAMTemplateHeaders.map(header => {
    return header.key;
});

export const IPSNonEAMBuyerProhibitedColumns = [
    'unitCost',
    'total'
];
export const IPSNonEAMHeaderListForCSV = IPSNonEAMTemplateHeaders.map(header => {
    return header.label;
}).join() + '\n';